import React, { useState } from 'react';
import axios from 'axios';
import Success from '../../../equipmentSurveys/components/Success';
import Submit from '../../../equipmentSurveys/components/Submit';
import BasicInfoUnitForm from '../../components/BasicInfoUnitForm';
import AdditionalBasicInfoFields from './AdditionalBasicInfoFields';
import NaturalDisasterQuestion from '../../components/NaturalDisasterQuestion';
import RenderError from '../../components/RenderError';

function BasicInfo({
  applicationData: {
    aid,
    unitOne = {},
    unitOneReceipt,
    unitTwo,
    unitTwoReceipt,
    naturalDisaster,
    disasterZipcode,
    equipment_counts: { BuildingHeat }
  } = {},
  setApplicationData,
  initialView,
  setView
}) {
  const [numberOfUnits, setNumberOfUnits] = useState(
    unitTwo !== undefined && Object.keys(unitTwo).length > 0 ? 2 : 1
  );
  const [numberOfUnitsError, setNumberOfUnitsError] = useState('');

  let initialState = {
    aid: aid ?? '',
    unitOne: {
      purchaseDate: unitOne.purchaseDate ?? '',
      purchaseAmount: unitOne.purchaseAmount ?? 0,
      manufacturer: unitOne.manufacturer ?? '',
      model: unitOne.model ?? '',
      serialNumber: unitOne.serialNumber ?? '',
      receipt: unitOneReceipt ?? '',
      equipmentDealer: unitOne.equipmentDealer ?? '',
      state: unitOne.state ?? '',
      typeOfSite1: unitOne.typeOfSite ?? '',
      buildingSquareFeet: unitOne.buildingSquareFeet ?? 0,
      weeksOfHeatPerYear: unitOne.weeksOfHeatPerYear ?? 0,
      buildingTemperature: unitOne.buildingTemperature ?? 0,
      connectedToGrid1: unitOne.connectedToGrid ?? ''
    },
    naturalDisaster: naturalDisaster ?? '0',
    zipcode: disasterZipcode ?? ''
  };

  if (unitTwo !== undefined) {
    initialState = {
      ...initialState,
      unitTwo: {
        purchaseDate: unitTwo.purchaseDate ?? '',
        purchaseAmount: unitTwo.purchaseAmount ?? 0,
        manufacturer: unitTwo.manufacturer ?? '',
        model: unitTwo.model ?? '',
        serialNumber: unitTwo.serialNumber ?? '',
        receipt: unitTwoReceipt ?? '',
        equipmentDealer: unitTwo.equipmentDealer ?? '',
        state: unitTwo.state ?? '',
        typeOfSite2: unitTwo.typeOfSite ?? [],
        buildingSquareFeet: unitTwo.buildingSquareFeet ?? 0,
        weeksOfHeatPerYear: unitTwo.weeksOfHeatPerYear ?? 0,
        buildingTemperature: unitTwo.buildingTemperature ?? 0,
        connectedToGrid2: unitTwo.connectedToGrid ?? ''
      }
    };
  }

  const [formData, setFormData] = useState(initialState);
  const [errors, setErrors] = useState([]);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState('');

  const handleUnitsSelect = (event) => {
    setNumberOfUnitsError('');
    const { value } = event.target;
    setNumberOfUnits(value);

    if (value > 1) {
      if (BuildingHeat === 2) {
        setNumberOfUnitsError(
          'You have reached the maximum of 2 building heat applications per year.'
        );
      } else {
        setFormData({
          ...formData,
          unitTwo: {
            purchaseDate: unitTwo !== undefined ? unitTwo.purchaseDate : '',
            purchaseAmount: unitTwo !== undefined ? unitTwo.purchaseAmount : 0,
            engineType: unitTwo !== undefined ? unitTwo.engineType : '',
            manufacturer: unitTwo !== undefined ? unitTwo.manufacturer : '',
            model: unitTwo !== undefined ? unitTwo.model : '',
            serialNumber: unitTwo !== undefined ? unitTwo.serialNumber : '',
            receipt: unitTwo !== undefined ? unitTwoReceipt : '',
            equipmentDealer:
              unitTwo !== undefined ? unitTwo.equipmentDealer : '',
            typeOfSite2: unitTwo !== undefined ? unitTwo.typeOfSite2 : '',
            buildingSquareFeet:
              unitTwo !== undefined ? unitTwo.buildingSquareFeet : 0,
            weeksOfHeatPerYear:
              unitTwo !== undefined ? unitTwo.weeksOfHeatPerYear : 0,
            buildingTemperature:
              unitTwo !== undefined ? unitTwo.buildingTemperature : 0,
            connectedToGrid2:
              unitTwo !== undefined ? unitTwo.connectedToGrid : ''
          }
        });
      }
    } else {
      let newFormData = formData;
      delete formData.unitTwo;
      setFormData(newFormData);
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setLoading(true);
    setSuccess('');
    let data = new FormData();
    data.append('aid', formData.aid);
    Object.keys(formData.unitOne).forEach((key) => {
      data.append(`unit1${key}`, formData.unitOne[key]);
    });
    if ('unitTwo' in formData) {
      Object.keys(formData.unitTwo).forEach((key) => {
        data.append(`unit2${key}`, formData.unitTwo[key]);
      });
    }
    data.append('naturalDisaster', formData.naturalDisaster);
    if ('zipcode' in formData) {
      data.append('zipcode', formData.zipcode);
    }

    axios
      .post(
        window.wlPipConfig.ajaxUrl +
          '?action=wl_fip_save_building_heat_basic_info',
        data
      )
      .then((res) => {
        setLoading(false);
        setErrors([]);
        setSuccess(res.data.message);
        setApplicationData(res.data.applicationData);
        setTimeout(() => setView(initialView), 1000);
      })
      .catch((err) => {
        setLoading(false);
        setErrors(err.response.data.data);
      });
  };

  return (
    <div className="fip-equipment-survey grid u--padding-right-20">
      <div className="grid__col-xs-12">
        <div className="form__field form__field--required">
          <label className="form__label">
            How many units do you have for this application?
          </label>
          <div className="form__select form__select--lg">
            <select onChange={handleUnitsSelect} defaultValue={numberOfUnits}>
              <option value="1">One</option>
              {(aid || BuildingHeat < 1) && <option value="2">Two</option>}
            </select>
            <RenderError error={numberOfUnitsError} />
          </div>
        </div>
        <BasicInfoUnitForm
          equipmentType={'building_heat'}
          formData={formData}
          setFormData={setFormData}
          errors={errors}
        >
          <AdditionalBasicInfoFields />
        </BasicInfoUnitForm>
        {numberOfUnits > 1 && !numberOfUnitsError && (
          <BasicInfoUnitForm
            two={true}
            equipmentType={'building_heat'}
            formData={formData}
            setFormData={setFormData}
            errors={errors}
          >
            <AdditionalBasicInfoFields />
          </BasicInfoUnitForm>
        )}
        <NaturalDisasterQuestion
          formData={formData}
          setFormData={setFormData}
          errors={errors}
        />
        <Submit
          loading={loading}
          handleSubmit={handleSubmit}
          text="Save Section"
          errors={errors}
          success={success}
        />
        {success && <Success success={success} />}
      </div>
    </div>
  );
}

BasicInfo.displayName = 'BasicInfo'; // because WebPack renames the function
export default BasicInfo;
